export default {
  MANDATAIRE_JUDICIAIRE: 0,
  AVOCAT: 1,
  ADMINISTRATEUR_JUDICIARE: 2,
  EXPERT_COMPTABLE: 3,
}